<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('requests')"
          :directory="$t('')"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            :disabled="disabledsupport"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>
      <div class="alert alert-info alert-dismissible fade show col-12 text-center" role="alert" v-if="disabledsupport">
        Usted consta como gestor de apoyo en este proceso.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col-md-12">
        <h5>{{ $t("type_request") }}: {{ app_type }}</h5>
        <br />
        <legend v-if="observations.length > 0">
          <p class="text-primary"><small>Observaciones</small></p>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="observations.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">Observación</th>
              <th scope="col">Fecha</th>
              <th scope="col">Usuario</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, obs) in observations" :key="obs">
              <td>{{ value.observation }}</td>
              <td>{{ dateToString(value.created_at) }}</td>
              <td>{{ value.user.full_name }}</td>
            </tr>
          </tbody>
        </table>
        <br />
          <div class="mt-2">
          <strong>Solicitud de acreditación firmada</strong>
          <br />
          <a
            class="btn btn-success"
            :href="`${request_signed}`"
            target="_blank"
          >
            <app-icon name="file" /> Ver</a
          >
        </div>
        <br />
        <app-tab
          :tabs="tabsHorizontal"
          :accreditation-application-id="accreditationApplicationId"
          type="horizontal"
        />
      </div>
      <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="modal-confirm-id"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea procesar este registro?"
        firstButtonName="Aceptar"
        secondButtonName="Cancelar"
        modalClass="success"
        icon="cpu"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
import * as actions from "../../apiUrl";
export default {
  name: "Form",
  mixins: [FormMixin],
  components: {},
  props: {
    accreditationApplicationId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      observations: "",
      request_signed:"",
      disabledsupport: false,
      tabsHorizontal: [
        // {
        //   icon: "briefcase",
        //   name: this.$t("general"),
        //   component: "FormGeneralTechnical",
        //   permission: "",
        // },
        // {
        //   icon: "home",
        //   name: this.$t("organization"),
        //   component: "FormOrganizationTechnical",
        //   permission: "",
        // },
        {
          icon: "send",
          name: this.$t("Alcances"),
          component: "scopest-index",
          permission: "",
        },
        {
          icon: "align-center",
          name: this.$t("Verificación de la documentación recibida"),
          component: "VerifyDocumentationTechnical",
          permission: "",
        },
        {
          icon: "paperclip",
          name: this.$t("annexes"),
          component: "FormAnnexesTechnical",
          permission: "",
        },
        {
          icon: "award",
          name: this.$t("Declaración para iniciar el proceso"),
          component: "DeclarationStartProccessTechnical",
          permission: "",
        },
        {
          icon: "file-minus",
          name: this.$t("Aprobación de solicitud"),
          component: "FormSendRequestTechnical",
          permission: "",
        },
      ],
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accreditationApplicationId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = "/accreditationtechnicalreview/accreditations";
    },
    data() {
      let url = `${actions.ACCREDITATIONS_APPLICATIONS}/form/${this.accreditationApplicationId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            const {
              accreditation_area: area,
              accreditation_activity: activity,
              accreditation_type: type,
            } = response.data.app;
            this.app_type = `${area.name} - ${activity.name}`;
            this.$store.state.accreditation.app = response.data.app;
            this.observations = response.data.observations;
            this.request_signed = response.data.app.request_signed.full_url
          
            this.axiosGet(
              `/accreditations/session/getauth`
            )
              .then((rsession) => {
                if (rsession.status == 200) {
                  if (response.data.app.support_technique == rsession.data && response.data.app.responsible_technician != response.data.app.support_technique) {
                    this.disabledsupport = true;
                  } else {
                    this.disabledsupport = false;
                  }
                  localStorage.setItem("auth_id", this.disabledsupport);
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                this.preloader = false;
              });
          }
        })
        .catch((error) => {
          console.log("Form: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    openRequest(){

    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD HH:mm") : null;
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `/sendRequesttechnicalreview/process/${this.accreditationApplicationId}`;
      this.deleteLoader = true;
      axiosPatch(url)
        .then((res) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data.status == true) {
            this.$toastr.s("Registro procesado con éxito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data.message);
          }
        })
        .catch(({ error }) => {});
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>
